import { NotificationModel } from 'api/models';
import { readNotificationsByIds } from 'api/services';
import DataLoader from 'dataloader';
import { useEffect } from 'react';

const batchNotificationProcessing = async (keys: string[]) => {
    const resultMap = keys.reduce(
        (acc, cur) => {
            acc[cur] = true;
            return acc;
        },
        {} as { [x: string]: boolean }
    );

    await readNotificationsByIds(keys);

    return keys.map((key) => resultMap[key]);
};

const readNotificationLoader = new DataLoader(
    async (keys) => {
        return batchNotificationProcessing(keys as string[]);
    },
    { batchScheduleFn: (callback) => setTimeout(callback, 1000) } // Read comments after 1 second to prevent race condition with refetching
);

interface UseNotificationReadOptions {
    notification: NotificationModel;
    isInView: boolean;
}

const useNotificationRead = (options: UseNotificationReadOptions) => {
    const { notification, isInView } = options;

    useEffect(() => {
        if (!isInView) return;

        // If notification has already been read
        if (notification.read) return;

        readNotificationLoader.load(notification._id);
    }, [isInView, notification._id, notification.read]);
};

export default useNotificationRead;
